var render = function render(){var _vm=this,_c=_vm._self._c;return _c('z-list',{staticClass:"z-filelist",class:_vm.buildClass,attrs:{"styled":false,"size":_vm.size,"tag":"ul"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }